/**
 * Created by Andrey Popov on 9/19/25.
 */

const ClipboardService = function () {
    cleverapps.EventEmitter.call(this);

    this.countOfCopiedItems = 0;

    this.init();
};

ClipboardService.prototype = Object.create(cleverapps.EventEmitter.prototype);
ClipboardService.prototype.constructor = ClipboardService;

ClipboardService.prototype.init = function () {
    this.copyHandlers = ClipboardService.REGISTERED_COPY_HANDLERS.map((CopyHandler) => new CopyHandler());
    this.pasteHandlers = ClipboardService.REGISTERED_PASTE_HANDLERS.map((PasteHandler) => new PasteHandler());

    const isTextElementActive = function () {
        const el = document.activeElement;
        return el && (el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.isContentEditable);
    };

    document.addEventListener("copy", (e) => {
        if (isTextElementActive()) {
            return;
        }

        e.preventDefault();

        this.copy();
    });

    document.addEventListener("paste", (e) => {
        if (isTextElementActive()) {
            return;
        }

        e.preventDefault();

        this.paste();
    });
};

ClipboardService.prototype.copy = function () {
    let data = null;
    for (let i = 0; i < this.copyHandlers.length; i++) {
        const handler = this.copyHandlers[i];
        if (handler.isApplicable()) {
            data = handler.copy();
            break;
        }
    }

    if (data) {
        cleverapps.copyToClipboard(data, () => {
            this.afterCountChanged(data);
        });
    } else {
        console.warn("No applicable copy handler found");
    }
};

ClipboardService.prototype.paste = function () {
    navigator.clipboard.readText().then((data) => {
        for (let i = 0; i < this.pasteHandlers.length; i++) {
            const handler = this.pasteHandlers[i];
            if (handler.isApplicable(data)) {
                handler.paste(data);
                return;
            }
        }
        console.warn("No applicable paste handler found");
    }).catch((e) => {
        console.error("Clipboard read error", e);
    });
};

ClipboardService.prototype.refreshClipboardData = function () {
    navigator.clipboard.readText().then((data) => {
        this.afterCountChanged(data);
    }).catch((e) => {
        console.error("Clipboard refresh error", e);
    });
};

ClipboardService.prototype.getCountOfCopiedItems = function () {
    return this.countOfCopiedItems;
};

ClipboardService.prototype.afterCountChanged = function (data) {
    for (let i = 0; i < this.pasteHandlers.length; i++) {
        const handler = this.pasteHandlers[i];
        if (handler.isApplicable(data)) {
            this.countOfCopiedItems = handler.countItems(data);
            break;
        }
    }

    this.trigger("changed");
};

ClipboardService.REGISTERED_COPY_HANDLERS = [];
ClipboardService.REGISTERED_PASTE_HANDLERS = [];